interface Props {
  className?: string;
}

export default function FilledStarIcon({className}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      className={className}>
      <path
        fillRule="nonzero"
        d="M9 14.925 3.438 18 4.5 11.488 0 6.875l6.219-.95L9 0l2.781 5.925 6.219.95-4.5 4.613L14.562 18z"
      />
    </svg>
  );
}
